import { generatePath } from "react-router-dom";
import Link from "./Link";

export default class PillarMerchantLink extends Link {
  constructor(merchantId, name, icon, path, component, authenticationName, pillarMerchantId) {
    super(merchantId, name, icon, path, component, authenticationName);
    this.pillarMerchantId = pillarMerchantId;
  }

  getLink() {
    return generatePath(this.path, { merchantId: this.merchantId, pillarMerchantId: this.pillarMerchantId });
  }
}
